import person from '@/api/person'
import _ from 'lodash'
import { person as PersonModel } from '@/api/models'
import { mergeUserContext } from '@/store/helpers'

const personFields = require('./data/person-form-field-definitions.json')

// initial state
const state = {
  allPersons: [],
  allDashboardSearchPersons: [],
  allDashboardSearchPersonsResponse: null,
  viewPerson: Object.assign({}, PersonModel),
  createPerson: Object.assign({}, PersonModel),
  editPerson: Object.assign({}, PersonModel),
  recentlyCreatedPerson: false,
  showCreatedModal: false,
  showUpdatedModal: false,
  personRecordCount: 0,
  errors: false,
  personFields: personFields.items,
  personTotalCount: 0
}

/*
 * Vuex getters
 * https://vuex.vuejs.org/guide/getters.html
 */
const getters = {
  getAllPersons: state => state.allPersons,
  getAllDashboardSearchPersons: state => state.allDashboardSearchPersons,
  getAllDashboardSearchPersonsResponse: state => state.allDashboardSearchPersonsResponse,
  getViewPerson: state => state.viewPerson,
  getCreatePerson: state => state.createPerson,
  getRecentlyCreatedPerson: state => state.recentlyCreatedPerson,
  getEditPerson: state => state.editPerson,
  showCreatedModal: state => state.showCreatedModal,
  showUpdatedModal: state => state.showUpdatedModal,
  syncViewPerson: state => state.syncViewPerson,
  getPersonFields: state => {
    return _.filter(state.personFields, (f) => _.isUndefined(f.showOnPersonView) || (!_.isUndefined(f.showOnPersonView) && f.showOnPersonView))
  },
  getPersonRecordCount: state => state.personRecordCount,
  getPersonYesNoFields: state => _.filter(personFields.items, (i) => i.yesNo),
  getPersonOtherFields: state => _.filter(personFields.items, (i) => i.other && i.name !== 'ls_conclusion'),
  getPersonOtherFieldsLA: state => _.filter(personFields.items, (i) => i.other),
  getPersonTotalCount: state => state.personTotalCount
}

/*
 * Vuex actions
 * https://vuex.vuejs.org/guide/actions.html
 */
const actions = {
  // How many do we have?
  async getPersonRecordCount ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    var response = await person.getPersonRecordCount(payload)
    response = response.body

    commit('setPersonRecordCount', response.data)
    return response.data
  },

  // Multi
  async getPersons ({ commit, state }, payload) {
    var response = await person.getPersons(payload)
    response = response.body
    console.log(response)

    commit('setPersons', response)
    return response
  },

  // Search
  async getAllDashboardSearchPersons ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    const response = await person.getDashboardSearchPersons(payload)
    let { data, count } = response.body || {}

    if (!Array.isArray(data)) {
      data = []
    }

    commit('setAllDashboardSearchPersons', data)
    commit('setAllDashboardSearchPersonsResponse', data)
    commit('SET_PERSON_TOTAL_COUNT', count)
    return response
  },

  // Single View
  async getPerson ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    var response = await person.getPerson(payload)
    response = response.body

    if (_.isArray(response)) {
      response = response.pop()
    }

    commit('setPerson', response)
  },

  // Create
  async createPerson ({commit, state, rootState}, payload) {
    payload = mergeUserContext(payload, rootState)

    var response = await person.createPerson(payload)
    response = response.body

    if (response.error) {
      state.error = response.error
      state.errors.push(state.error)
    } else {
      commit('setRecentlyCreatedPerson', response)
      commit('setShowCreatedModal', true)
      commit('addToPersonsList', response)
      commit('setCreatePerson', Object.assign({}, PersonModel))
    }
  },

  // Single View - Edit
  async getPersonForEdit ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    var response = await person.getPerson(payload)
    response = response.body

    if (_.isArray(response)) {
      response = response.pop()
    }
    commit('setEditPerson', response)
  },

  // Sync person record
  async syncViewPerson ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    var response = await person.getPerson(payload)
    response = response.body

    if (_.isArray(response)) {
      response = response.pop()
    }

    commit('setPerson', response)
  },

  // Update/Edit
  async updatePerson ({ commit, state, rootState }, payload) {
    delete payload.sharingGroups
    delete payload.organizationCreator
    delete payload.organizationOwner
    delete payload.person
    delete payload.cseits
    delete payload.laborScreenings
    delete payload.oldTraffickingScreenings
    delete payload.traffickingScreenings

    payload = mergeUserContext(payload, rootState)

    console.log(payload)

    const user = _.clone(this._vm.$auth.user())

    payload.updatedBy = user.id

    // Ensure we don't try to update the assessments array
    if (payload.assessments) {
      delete payload.assessments
    }

    var response = await person.updatePerson(payload)
    console.log(response)
    response = response.body

    // Only show modal if everything went okay
    if (response) {
      commit('setShowUpdatedModal', true)
      commit('updatePersonsList', response)
      commit('setPerson', response)
    }

    if (response.status !== 200) {
      // TO DO - Set something where we can surface server errors
    }
  },

  async updatePersonToggle ({ commit, state, rootState }, payload) {
    delete payload.sharingGroups
    delete payload.organizationCreator
    delete payload.organizationOwner
    delete payload.person
    delete payload.cseits
    delete payload.laborScreenings
    delete payload.oldTraffickingScreenings
    delete payload.traffickingScreenings

    payload = mergeUserContext(payload, rootState)

    console.log(payload)

    const user = _.clone(this._vm.$auth.user())

    payload.updatedBy = user.id

    // Ensure we don't try to update the assessments array
    if (payload.assessments) {
      delete payload.assessments
    }

    var response = await person.updatePerson(payload)
    response = response.body
    console.log(response)

    // Only show modal if everything went okay
    if (response) {
      // commit('setShowUpdatedModal', true)
      commit('updatePersonsList', response)
      commit('setPerson', response)
    }

    if (response.status !== 200) {
      // TO DO - Set something where we can surface server errors
    }
  }
}

/*
 * Vuex mutations
 * https://vuex.vuejs.org/guide/mutations.html
 */
const mutations = {
  setPersonRecordCount (state, count) {
    state.personRecordCount = count
  },

  setPersons (state, records) {
    if (!_.isEmpty(records)) {
      state.allPersons = records
    }
  },

  setAllDashboardSearchPersons (state, records) {
    state.allDashboardSearchPersons = records || []
  },

  setAllDashboardSearchPersonsResponse (state, records) {
    state.allDashboardSearchPersonsResponse = _.isArray(records)
  },

  setPerson (state, record) {
    if (_.isEmpty(record)) {
      state.viewPerson = Object.assign({}, PersonModel)
    } else {
      state.viewPerson = record
    }
  },

  resetViewPerson (state) {
    state.viewPerson = Object.assign({}, PersonModel)
  },

  setCreatePerson (state, record) {
    state.createPerson = record
  },

  setRecentlyCreatedPerson (state, record) {
    state.recentlyCreatedPerson = record
  },

  resetEditPerson (state, record) {
    state.editPerson = Object.assign({}, PersonModel)
  },

  setEditPerson (state, record) {
    state.editPerson = record
  },

  setShowCreatedModal (state, response) {
    state.showCreatedModal = response
  },

  setShowUpdatedModal (state, response) {
    state.showUpdatedModal = response
  },

  addToPersonsList (state, newRecord) {
    var oldIndex = _.findIndex(state.allPersons, (r) => r._id === newRecord._id)

    if (oldIndex < 0) {
      state.allPersons.unshift(newRecord)
    } else {
      // Uh-oh - we tried to add a record that's already in our list
    }
  },

  // After updating someone, update them in the list
  updatePersonsList (state, updatedRecord) {
    // Find person in all persons
    var oldIndex = _.findIndex(state.allPersons, (r) => r._id === updatedRecord._id)

    if (oldIndex >= 0) {
      // Remove old record and Add new updated record
      state.allPersons = state.allPersons.splice(oldIndex, 1, updatedRecord)
    }
  },

  UPDATE_TRANSFERRED_PERSON (state, record) {
    state.viewPerson = record
  },

  SET_PERSON_TOTAL_COUNT (state, record) {
    state.personTotalCount = record
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/persons.js